import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ColoredText from '../components/ColoredText';
import defaultMatrice from '../utils/defaultMatrice';
import './StoryPage.css';

// Import des images depuis assets
import photo1 from '../assets/story/photo 1 - leo indien - 2000px.jpg';
import photo2 from '../assets/story/photo 2 - leo papa ursule - 2000px.jpg';
import photo3 from '../assets/story/photo 3 - leo couleurs - 1600px.jpg';
import photo4 from '../assets/story/photo 4 - leo dans un champ - 1600px.jpg';
import photo5 from '../assets/story/photo 5 - maitresse - 1300px.jpg';
import photo6 from '../assets/story/photo 6 - leo et papa scary - 1600px.jpg';
import photo7 from '../assets/story/photo 7 - leo minecraft - 2000px.jpg';
import photo8 from '../assets/story/photo 8 - leo code - 1800px.jpg';
import photo9 from '../assets/story/photo 9 - leo lit dans la voiture - 2000px.jpg';
import photo10 from '../assets/story/photo 10 - leo dans le train - 1600px.jpg';
import photo11 from '../assets/story/photo 11 - leo code synestesia - 1600px.jpg';

// Import des magnets décoratifs depuis assets
import magnet1 from '../assets/magnet/01 mont saint michel.png';
import magnet2 from '../assets/magnet/02 kapadokya.png';
import magnet3 from '../assets/magnet/03  van gogh.png';
import magnet4 from '../assets/magnet/04 the wall.png';
import magnet5 from '../assets/magnet/05 coccinelle.png';
import magnet6 from '../assets/magnet/06 funny pizza.png';
import magnetA from '../assets/magnet/A lettre.png';
import magnetB from '../assets/magnet/B lettre.png';
import magnetC from '../assets/magnet/C letter.png';
import magnetD from '../assets/magnet/D letter.png';
import magnetE from '../assets/magnet/E letter.png';
import magnetF from '../assets/magnet/F letter.png';
import magnetG from '../assets/magnet/G letter.png';
import magnetH from '../assets/magnet/H letter.png';
import magnetJ from '../assets/magnet/J letter.png';
import magnetLutin from '../assets/magnet/07 lutin.png';
import leoThecircle from '../assets/circle/Leo Thecircle.png';

const StoryPage = () => {
  const { t, i18n } = useTranslation();

  const storySections = [
    {
      id: 1,
      textKey: 'story.section1',
      image: photo1,
      imageAlt: "photo1"
    },
    {
      id: 2,
      textKey: 'story.section2',
      image: photo2,
      imageAlt: "photo2"
    },
    {
      id: 3,
      textKey: 'story.section3',
      image: photo3,
      imageAlt: "photo3"
    },
    {
      id: 4,
      textKey: 'story.section4',
      image: photo4,
      imageAlt: "photo4"
    },
    {
      id: 5,
      textKey: 'story.section5',
      image: photo5,
      imageAlt: "photo5"
    },
    {
      id: 6,
      textKey: 'story.section6',
      image: photo6,
      imageAlt: "photo6"
    },
    {
      id: 7,
      textKey: 'story.section7',
      image: photo7,
      imageAlt: "photo7"
    },
    {
      id: 8,
      textKey: 'story.section8',
      image: photo8,
      imageAlt: "photo8"
    },
    {
      id: 10,
      textKey: 'story.section9',
      image: photo9,
      imageAlt: "photo9"
    },
    {
      id: 11,
      textKey: 'story.section10',
      image: photo10,
      imageAlt: "photo10"
    },
    {
      id: 12,
      textKey: 'story.section11',
      image: photo11,
      imageAlt: "photo11"
    },
    {
      id: 13,
      textKey: 'story.section12',
      image: null,
      imageAlt: ""
    },
    {
      id: 14,
      textKey: 'story.section13',
      image: null,
      imageAlt: ""
    },
    {
      id: 15,
      textKey: 'story.section14',
      image: null,
      imageAlt: ""
    }
  ];

  // Mapping des magnets aux sections spécifiques
  const magnetMapping = {
    // Section 1 : 2 magnets verticaux (mont saint michel + kapadokya)
    1: [
      { src: magnet1, rotation: -15, position: 'top' },
      { src: magnet2, rotation: 12, position: 'bottom' },
    ],
    2: { src: magnet6, rotation: 10 },
    3: { src: magnet3, rotation: -8 },
    4: { src: magnetLutin, rotation: -12 },
    5: { src: magnet4, rotation: 18 },
    6: [
      { src: magnet5, rotation: -12, offsetX: -60 },
      { src: magnet5, rotation: 15, offsetX: 60 },
    ],
  };

  // Mapping des magnets sur les post-its (paires aux coins)
  const postItMagnetMapping = {
    // Section 7 : A et B sur le post-it "synesthète"
    7: [
      { src: magnetA, rotation: -15, position: 'top-left' },
      { src: magnetB, rotation: 18, position: 'bottom-right' },
    ],
    // Section 8 : C et D sur le post-it "codé ensemble"
    8: [
      { src: magnetC, rotation: -12, position: 'top-right' },
      { src: magnetD, rotation: 20, position: 'bottom-left' },
    ],
    // Section 10 : E et F sur le post-it "fastoche"
    10: [
      { src: magnetE, rotation: -18, position: 'top-left' },
      { src: magnetF, rotation: 22, position: 'bottom-right' },
    ],
    // Section 11 : G et H sur le post-it "plus grand"
    11: [
      { src: magnetG, rotation: -20, position: 'top-right' },
      { src: magnetH, rotation: 15, position: 'bottom-left' },
    ],
    // Section 12 : J seul sur le post-it "projets d'études" (I n'existe pas)
    12: [
      { src: magnetJ, rotation: -10, position: 'top-left' },
    ],
  };

  return (
    <div className="story-page">
      <Navbar />
      <main className="story-main">
        <div className="story-container">
          {storySections.map((section, index) => {
            const hasImage = !!section.image;
            const hasText = !!section.textKey;
            const isTextOnly = !hasImage && hasText;
            const sectionText = section.textKey ? t(section.textKey) : '';
            
            // Rotation aléatoire pour chaque photo (entre -8 et 8 degrés)
            const rotation = hasImage ? (section.id * 7.3) % 16 - 8 : 0;
            
            // Couleurs de post-its différentes pour chaque section
            const postItColors = [
              '#ffeb3b', // Jaune
              '#ff9800', // Orange
              'rgba(238, 119, 159, 1)', // Rouge
              '#e91e63', // Rose
              'rgba(154, 163, 214, 1)', // Violet
              'rgba(148, 112, 210, 1)', // Violet foncé
              'rgba(160, 172, 238, 1)', // Bleu
              '#2196f3', // Bleu clair
              '#00bcd4', // Cyan
              '#4caf50', // Vert
              '#8bc34a', // Vert clair
              '#ffc107', // Jaune foncé
              '#ff5722', // Orange foncé
              '#795548', // Marron
              'rgba(30, 38, 42, 1)'  // Bleu gris
            ];
            const postItColor = postItColors[section.id % postItColors.length];
            const sectionMagnet = magnetMapping[section.id];
            const postItMagnets = postItMagnetMapping[section.id];
            
            return (
              <section 
                key={section.id} 
                className={`story-section ${index % 2 === 0 ? 'story-section-left' : 'story-section-right'} ${isTextOnly ? 'story-section-text-only' : ''} ${section.id === 13 || section.id === 14 ? 'story-section-close' : ''} ${section.id === 15 ? 'story-section-singularity' : ''}`}
              >
                {section.image && (
                  <div className="story-image-container">
                    <div className="magnet-photo-wrapper" style={{ transform: `rotate(${rotation}deg)` }}>
                      <div className="magnet"></div>
                      <img 
                        src={section.image} 
                        alt={section.imageAlt} 
                        className="story-image"
                      />
                    </div>
                    {/* Magnets décoratifs autour de la photo pour la section 8 */}
                    {sectionMagnet && Array.isArray(sectionMagnet) && section.id === 8 && (
                      sectionMagnet.map((magnet, idx) => (
                        <div 
                          key={idx}
                          className={`section-decorative-magnet section-8-magnet section-8-magnet-${magnet.position}`}
                        >
                          <img
                            src={magnet.src}
                            alt={`Magnet décoratif section ${section.id} ${magnet.position}`}
                            className="decorative-magnet"
                            style={{
                              transform: `rotate(${magnet.rotation}deg)`,
                            }}
                          />
                        </div>
                      ))
                    )}
                  </div>
                )}
                {/* Magnets décoratifs verticaux pour la section 1 - entre l'image et le post-it */}
                {sectionMagnet && Array.isArray(sectionMagnet) && section.id === 1 && (
                  sectionMagnet.map((magnet, idx) => (
                    <div 
                      key={idx}
                      className={`section-decorative-magnet section-1-magnet section-1-magnet-${magnet.position}`}
                    >
                      <img
                        src={magnet.src}
                        alt={`Magnet décoratif section ${section.id} ${magnet.position}`}
                        className="decorative-magnet"
                        style={{
                          transform: `rotate(${magnet.rotation}deg)`,
                        }}
                      />
                    </div>
                  ))
                )}
                {/* Magnets coccinelle côte à côte pour la section 6 */}
                {sectionMagnet && Array.isArray(sectionMagnet) && section.id === 6 && (
                  sectionMagnet.map((magnet, idx) => (
                    <div 
                      key={idx}
                      className="section-decorative-magnet section-6-magnet"
                      style={{
                        top: '50%',
                        left: '601px',
                        transform: `translate(calc(-50% + ${magnet.offsetX}px), -50%)`,
                        zIndex: 15,
                      }}
                    >
                      <img
                        src={magnet.src}
                        alt={`Magnet décoratif section ${section.id}`}
                        className="decorative-magnet"
                        style={{
                          transform: `rotate(${magnet.rotation}deg)`,
                        }}
                      />
                    </div>
                  ))
                )}
                {/* Magnet décoratif entre la photo et le texte pour les autres sections */}
                {sectionMagnet && !Array.isArray(sectionMagnet) && section.image && hasText && (
                  <div className="section-decorative-magnet">
                    <img
                      src={sectionMagnet.src}
                      alt={`Magnet décoratif section ${section.id}`}
                      className="decorative-magnet"
                      style={{
                        transform: `rotate(${sectionMagnet.rotation}deg)`,
                      }}
                    />
                  </div>
                )}
                {hasText && (
                  <>
                    {section.id === 15 ? (
                      <Link to="/login" className="singularity-image-link" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                        <div className="singularity-image-container">
                          <img 
                            src={leoThecircle} 
                            alt="Leo Thecircle" 
                            className="singularity-image"
                          />
                          <div 
                            className={`singularity-text ${sectionText.split(/\s+/).length > 3 ? 'singularity-text-multiline' : ''}`}
                            lang={i18n.language === 'tr' ? 'tr' : undefined}
                          >
                            {sectionText}
                          </div>
                        </div>
                      </Link>
                    ) : (
                      <div className="story-text-container">
                      <div 
                        className={`post-it ${section.id >= 15 ? 'post-it-adult' : section.id < 11 ? 'post-it-child' : section.id >= 11 && section.id < 15 ? 'post-it-default' : ''} ${section.id === 15 ? 'morphing-container' : ''}`} 
                        style={{ backgroundColor: postItColor, position: 'relative' }}
                      >
                        {postItMagnets && postItMagnets.map((magnet, idx) => (
                          <div 
                            key={idx}
                            className={`post-it-magnet post-it-magnet-${magnet.position}`}
                          >
                            <img
                              src={magnet.src}
                              alt={`Magnet post-it section ${section.id} ${magnet.position}`}
                              className="decorative-magnet"
                              style={{
                                transform: `rotate(${magnet.rotation}deg)`,
                              }}
                            />
                          </div>
                        ))}
                        <p 
                          className="story-text" 
                          data-section-id={section.id} 
                          lang={i18n.language === 'tr' ? 'tr' : undefined}
                        >
                          {section.id === 13 || section.id === 14 ? (
                            <ColoredText text={sectionText} matrice={defaultMatrice} />
                          ) : (
                            sectionText
                          )}
                        </p>
                      </div>
                      </div>
                    )}
                  </>
                )}
              </section>
            );
          })}
        </div>
      </main>
      <footer className="story-page-footer"></footer>
    </div>
  );
};

export default StoryPage;
